import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./ListOfInvoices.module.css";
import imageWhite from "../../assets/images/dashboard/list-of-invoice-white.svg";
import { TableOptions } from "../../utils/messageConstants";
import { Link } from "react-router-dom";
import { checkIfPermitted, Permissions } from "../../services/RolePermissionService";

let order = "desc";

export class ListOfInvoices extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleBtnClick = () => {
    if (order === "desc") {
      this.refs.table.handleSort("asc", "name");
      order = "asc";
    } else {
      this.refs.table.handleSort("desc", "name");
      order = "desc";
    }
  };

  render() {
    const dashboardData = this.props.dashboardCounts;
    return (
      <div>
        <div className={`card ${style.listOfInvoicesCard}`}>
          <Link to={checkIfPermitted(Permissions.VIEW_PAYMENT_TRANSACTION) 
          ? "/app/invoicelist" : "/app/dashboard"}>
            <div className={`card-header ${style.listOfInvoicesHeader}`}>
              <div className="d-flex align-items-center dashboard-list-box">
                <img src={imageWhite} alt="Inventory Audit Trail" />
              List Of Invoices
              </div>
              <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
            </div>
          <div className="card-body dashboard-time-table-wrapper">
            <BootstrapTable ref="table" data={dashboardData.invoiceList} options={TableOptions} version="4">
              <TableHeaderColumn
                dataField="billTo"
                isKey={true}
                // dataSort={true}
                width={"65%"}
              >
                Contact Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="amount"
                // dataSort={true}
                width={"35%"}
              >
                Amount
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
          </Link>
        </div>
      </div>
    );
  }
}


export default ListOfInvoices;

